// src/components/Accounting/AccountingTenantLedger.js

import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';

import { ServerConfig } from 'config';

// @material-ui/core
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';

// Use DetailsEditComponent directly (no modal, no button)
import { DetailsEditComponent } from 'components/EntryListAndEdit/EditComponent.js';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(12),
    },
  },
  headerComponent: { marginBottom: 20, paddingRight: 20 },
  header: { marginBottom: 8 },
}));

const AccountingTenantLedger = () => {
  const classes = useStyles();
  const token = useSelector((state) => state.auth.access_token);

  const [tenants, setTenants] = useState([]);
  const [selectedTenantId, setSelectedTenantId] = useState('');
  const [selectedTenant, setSelectedTenant] = useState(null);

  // ---------- Fetch tenants ----------
  const fetchTenants = async () => {
    const config = { headers: { 'Content-Type': 'application/json' } };

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/`, config);
    setTenants(results.data);
  };

  useEffect(() => {
    if (token) {
      fetchTenants();
    }
  }, [token]);

  if (!token) {
    return <Redirect to="/login" />;
  }

  const handleTenantChange = (event) => {
    const value = event.target.value;
    setSelectedTenant(null);

    const tenant = tenants.find((t) => String(t.id) === String(value)) || null;
    setSelectedTenant(tenant);
  };

  // No extra details fields in this simple version
  const editable_fields = [];
  const non_editable_fields = [];

  return (
    <div className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4} className={classes.headerComponent}>
          <Typography variant="h6" className={classes.header}>
            Tenant
          </Typography>
          <select
            className="form-select"
            name="tenant"
            id="tenant"
            value={selectedTenant?.id ?? ''}
            onChange={handleTenantChange}
          >
            <option value="">Please Select</option>
            {tenants.map((t) => (
              <option key={t.id} value={t.id}>
                {t.business_name}
              </option>
            ))}
          </select>
        </Grid>
      </Grid>

      {selectedTenant && (
        <>
          <Typography variant="body1">
            Selected tenant: <strong>{selectedTenant.business_name}</strong>
          </Typography>

          {/* Directly render the full form + ledger under the dropdown */}
          <DetailsEditComponent
            key={`tenant-ledger-${selectedTenant.id}`}
            rowData={{ id: selectedTenant.id  }}
            editable_fields={editable_fields}
            non_editable_fields={non_editable_fields}
            // For details: use tenant endpoint (we're not really editing anything now)
            detail_get_url={`${ServerConfig.SERVER_URL}/tenant/`}
            detail_put_url={undefined}
            detail_delete_url={undefined}
            // Ledger props – this is what actually matters
            ledger_get_url="/ledger/tenant/"          // GET SERVER_URL + '/ledger/tenant/' + tenantId
            ledger_insert_url="/ledger/insert_tenant/" // POST SERVER_URL + '/ledger/insert_tenant/' + tenantId
            ledger_allow_entries={true}
            show_machine_stats={undefined}
            showHeader={false}
          />
        </>
      )}
    </div>
  );
};

export default AccountingTenantLedger;
